import { createModel, createSaga, createReducer } from '@/store/tools';
import { put, takeEvery } from 'redux-saga/effects';
import http from '@/assets/api/http';

const dataList = { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 };
const model = {
    namespace: 'templatetrac',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getTemptracList': T('getTemptracList'),
            'getTemptracName': T('getTemptracName'),
            'getTemptracSigned': T('getTemptracSigned'),
            'getTemptracDownList': T('getTemptracDownList'),
        },
        actions: {
            'getTemptracList': A('getTemptracList'), // 模板列表数据
            'getTemptracName': A('getTemptracName'), // 模板名称下拉数据
            'getTemptracSigned': A('getTemptracSigned'), // 已签署列表数据
            'getTemptracDownList': A('getTemptracDownList'), // 协议下载列表数据
        },
        sagas: {
            'getTemptracList': S('getTemptracList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.FadadaMisService.selectFadadaContractList', 'POST'),
            'getTemptracName': S('getTemptracName', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum', 'POST'),
            'getTemptracSigned': S('getTemptracSigned', '/?cmd=com.xqxc.api.pig.mis.biz.platform.FadadaMisService.contractInfoListOfFadadaAsPage', 'POST'),
            'getTemptracDownList': S('getTemptracDownList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.FadadaMisService.exportAgreementQuery', 'POST'),
        },
        reducers: {
            'temptracList': R('getTemptracList', []),
            'temptracName': R('getTemptracName', []),
            'temptracSigned': R('getTemptracSigned', dataList),
            'temptracDownList': R('getTemptracDownList', []),
        }
    })
};
export default createModel(model);